import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const modifiers = {
  type: {
    primary: () => css`
      color: ${theme.colors.primary};
    `,
    success: () => css`
      color: 'green';
    `,
    error: () => css`
      color: 'red;
    `,
    info: () => css`
      color: ${theme.colors.gray6};
  `,
  },
};

const modalProps = {
  type: String,
  visible: Boolean,
};

export const ModalTypes = ['primary', 'success', 'error', 'info'] as const;

export type ModalProps = {
  type: typeof ModalTypes[number];
  visible: boolean;
};

export const Container = styled('div', modalProps)`
  ${({ type }: ModalProps) => css`
    align-items: center;
    background-color: ${theme.colors.white};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: justify;
    padding: 32px 32px;
    position: relative;
    text-align: justify;
    width: 85%;
    height: 80%;
    overflow: auto;
    ${modifiers.type[type]}
    img {
      word-wrap: normal|break-word|initial|inherit;
    }
    a {
      word-wrap: normal|break-word|initial|inherit;
    }
    span {
      word-wrap: normal|break-word|initial|inherit;
    }
    h6 {
      font-weight: ${theme.font.bold};
      margin-bottom: ${theme.spacings.medium};
      margin-top: ${theme.spacings.xlarge};
    }

    p {
      color: ${theme.colors.gray6};
      font-size: 14px;
      line-height: ${theme.font.light};
    }

    .close {
      position: absolute;
      right: 32px;
      top: 40px;

      &:hover {
        cursor: pointer;
      }

      &:focus {
        outline: none;
        box-shadow: ${theme.shadow.lv2};
      }
    }

    .buttons {
      display: flex;
      gap: ${theme.spacings.medium};
      margin-top: 32px;
    }
  `}
`;

export const Wrapper = styled('div', modalProps)`
  ${({ visible }: ModalProps) => css`
    align-items: center;
    background-color: rgba(0, 0, 0, .45);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 1;
    position: fixed;
    top: 0;
    transition: opacity .3s;
    width: 100%;
    z-index: ${theme.layers.overlay};

    ${!visible && 'opacity: 0; z-index: 0; pointer-events: none;'}
  `}
`;
